import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Subtitle,
    Title,
    IntroButton,
    ButtonContainer,
    DescriptionItemsContainer,
    SliderContainer,
    BrandDescription,
    BrandParagraph,
    BrandTitle,
    BrandText,
    BrandImage,
    HeaderContainer,
} from './styled';
import { PageSection } from 'components';
import {
    ALLIANCE_HEADER_LINKS,
    ALLIANCE_HEADER_LINKS_EN,
    OFFER_CARDS_EN,
    OFFER_CARDS_RU,
} from 'consts';
import {
    TitleSlider,
    Counter,
    SliderArrow,
} from 'containers/pages/for-governments/components/intro/styled';
import { Icon } from 'kl-b2c-ui-kit';
import Slider, { Settings } from 'react-slick';
import DOMPurify from 'dompurify';
import { OfferCard } from 'types';
import AllianceCard from '../alliance-card';
import { Title as BaseTitle } from '../../styled';
import {
    DotsContainer,
    DotsList,
} from 'containers/pages/for-businesses/components/reviews/styled';
import { SliderStyler } from 'containers/pages/for-businesses/components/courses/styled';

const sectionConfig = {
    CWrap: {
        css: {},
    },
    ContentArea: {
        css: {
            paddingTop: 100,
            paddingBottom: 90,
            display: 'block',
            zIndex: 5,

            '@media(max-width: 1023px)': {
                paddingBottom: 50,
            },
        },
    },
};

export const Intro = () => {
    const { t } = useTranslation('pages/academy-alliance');
    const [currentTitle, setCurrentTitle] = useState<number>(0);
    const locale = process.env.REACT_APP_LOCALE;

    const CAROUSEL_SETTINGS: Settings = {
        slidesToScroll: 2,
        infinite: false,
        slidesToShow: 2,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
        appendDots: (dots) => (
            <DotsContainer>
                <DotsList
                    styles={{
                        '.slick-active': {
                            background: '#7733FF',
                            opacity: '1',
                        },
                        li: {
                            opacity: '0.5',
                            background: '#7733FF',
                        },
                    }}>
                    {' '}
                    {dots}{' '}
                </DotsList>
            </DotsContainer>
        ),
    };

    const currentLink =
        locale === 'ru'
            ? ALLIANCE_HEADER_LINKS[currentTitle]
            : ALLIANCE_HEADER_LINKS_EN[currentTitle];

    return (
        <PageSection config={sectionConfig}>
            <HeaderContainer>
                <Title
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(t(`title-${currentTitle}`)),
                    }}
                />
                <Subtitle
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            t(`subtitle-${currentTitle}`)
                        ),
                    }}
                />

                <ButtonContainer>
                    <IntroButton
                        size={'large'}
                        onClick={() =>
                            currentLink.isMail
                                ? (window.location.href = `mailto:${currentLink.path}`)
                                : window.open(currentLink.path, '_blank')
                        }>
                        {currentTitle === 0 ? t('request') : t('go')}
                    </IntroButton>
                    <TitleSlider>
                        <SliderArrow
                            onClick={() => {
                                if (currentTitle !== 0) {
                                    setCurrentTitle((prev) => prev - 1);
                                }
                            }}>
                            <Icon
                                name={'ArrowLeftThin'}
                                color={'white'}
                                size={24}
                            />
                        </SliderArrow>
                        <Counter>
                            {currentTitle + 1} <span>/ 4</span>
                        </Counter>
                        <SliderArrow
                            onClick={() => {
                                if (currentTitle < 4 - 1) {
                                    setCurrentTitle((prev) => prev + 1);
                                }
                            }}>
                            <Icon
                                name={'ArrowRightThin'}
                                color={'white'}
                                size={24}
                            />
                        </SliderArrow>
                    </TitleSlider>
                </ButtonContainer>
            </HeaderContainer>

            <BrandDescription>
                <BrandText>
                    <BrandParagraph>{t('brand-description-1')}</BrandParagraph>
                    <BrandParagraph>{t('brand-description-2')}</BrandParagraph>
                    <BrandTitle>{t('our-goal')}</BrandTitle>
                </BrandText>
                <BrandImage>
                    <img
                        src={'/assets/images/alliance/alliance-k-letter.png'}
                        alt={'Alliance K-letter'}
                    />
                </BrandImage>
            </BrandDescription>

            <BaseTitle styles={{ marginBottom: '30px' }}>
                {t('intro-description-title')}
            </BaseTitle>

            <DescriptionItemsContainer>
                {(process.env.REACT_APP_LOCALE === 'ru'
                    ? OFFER_CARDS_RU
                    : OFFER_CARDS_EN
                ).map((item: OfferCard) => (
                    <AllianceCard key={item.front} config={item} />
                ))}
            </DescriptionItemsContainer>
            <SliderContainer>
                <SliderStyler>
                    <Slider {...CAROUSEL_SETTINGS}>
                        {(process.env.REACT_APP_LOCALE === 'ru'
                            ? OFFER_CARDS_RU
                            : OFFER_CARDS_EN
                        ).map((item: OfferCard, index: number) => (
                            <AllianceCard
                                key={`${item.front}-${index}`}
                                config={item}
                            />
                        ))}
                    </Slider>
                </SliderStyler>
            </SliderContainer>
        </PageSection>
    );
};
